/**
 * Runs before every other module, because `main.tsx` imports it first: the
 * router copies the page URL as its module loads, and a Slack code still in
 * the URL would then reach the login redirect, browser telemetry and the
 * history entry.
 */
import { stashSlackReturnFromUrl } from "@/lib/alerts/slack-connect";

stashSlackReturnFromUrl();
